import React from 'react';
import SectionHeader from '../ui/SectionHeader';
import Reveal from '../ui/Reveal';
import site from '../../data/site.json';
import './Process.css';

const Process = () => {
  return (
    <section className="process tra-section" id="process">
      <div className="tra-container">
        <SectionHeader
          eyebrow="How We Work"
          title="A proven process, every time"
          subtitle="No guesswork. A clear, repeatable framework that turns ambition into results."
          align="center"
        />

        <div className="process__grid">
          {site.process.map((p, i) => (
            <Reveal className="process-step" key={p.step} delay={i * 0.1}>
              <span className="process-step__num">{p.step}</span>
              <h3 className="process-step__title">{p.title}</h3>
              <p className="process-step__desc">{p.description}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;
